/**
 * Fonctions utilitaires de formatage
 */

/**
 * Formate une distance en mètres ou kilomètres
 */
export const formatDistance = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '?';
  return value >= 1000 ? `${(value / 1000).toFixed(1)} km` : `${value} m`;
};

/**
 * Formate une valeur en mètres
 */
export const formatMeters = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '?';
  return `${value} m`;
};

/**
 * Formate une durée en heures
 */
export const formatDuration = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '?';
  return `${value}h`;
};

/**
 * Formate une durée en heures (pour les Descriptions d'Ant Design)
 */
export const formatDurationForDisplay = (value: number | null | undefined): string => {
  return formatDuration(value);
};
